import { Flex } from 'antd';
import { FaLinkedin } from 'react-icons/fa';
import { FaGooglePlay } from 'react-icons/fa';
import { FaGithub } from 'react-icons/fa';
import { FaAppStoreIos } from 'react-icons/fa';
import { Link } from 'react-router-dom';
export const ContactsList: React.FC = () => (
	<Flex justify="center" gap={20} wrap="wrap">
		<Link target="_blank" to={'https://play.google.com/store/apps/dev?id=7723993169576060954&hl=en-US'}>
			<FaGooglePlay color="black" size={40} />
		</Link>
		<Link target="_blank" to={'https://play.google.com/store/apps/dev?id=7723993169576060954&hl=en-US'}>
			<FaAppStoreIos color="black" size={40} />
		</Link>
		<Link target="_blank" to={'https://www.linkedin.com/company/kaptis'}>
			<FaLinkedin color="black" size={40} />
		</Link>
		<Link target="_blank" to={'https://github.com/kaptis-studio'}>
			<FaGithub color="black" size={40} />
		</Link>
	</Flex>
);
